import ReactECharts from 'echarts-for-react';
import dayjs from 'dayjs';
import { benchmarkColors, chartGrid, chartText } from '../../lib/chartColors';
import AnnotatedTimeChart from './AnnotatedTimeChart';

export default function BenchmarkChart({data,metric='average_price',height=430,fuel='BENZINA'}){
  if(!data)return null;
  const scopes=data.scopes||[];
  const groups=data.series||{};
  const all=Object.values(groups).flat();
  const dates=[...new Set(all.map(x=>x.snapshot_date))].sort();
  const series=scopes.filter(s=>groups[s.key]?.length).map(scope=>{
    const map=Object.fromEntries(groups[scope.key].map(x=>[x.snapshot_date,Number(scope.key==='station'?x.price:x[metric])]));
    return {name:scope.name,type:'line',symbol:'none',showSymbol:false,connectNulls:false,data:dates.map(d=>map[d]??null),lineStyle:{width:scope.key==='station'?4:2.2,color:benchmarkColors[scope.key]||'#6c5d62',type:scope.key==='station'?'solid':'dashed',cap:'round'},itemStyle:{color:benchmarkColors[scope.key]||'#6c5d62'},emphasis:{focus:'series'}};
  });
  const option={
    animationDuration:420,
    grid:{left:54,right:14,top:74,bottom:42},
    legend:{top:4,type:'scroll',textStyle:{fontFamily:'Rubik',fontSize:11,color:chartText,fontWeight:500},itemWidth:18,itemHeight:8},
    tooltip:{trigger:'axis',backgroundColor:'#fff8f9',borderWidth:0,padding:12,textStyle:{fontFamily:'Rubik',color:'#24191c'},extraCssText:'border-radius:18px;box-shadow:0 2px 8px rgba(35,25,27,.14);',formatter:(params)=>{const i=params?.[0]?.dataIndex??0;const d=dates[i]?dayjs(dates[i]).format('DD/MM/YYYY'):'';return `<b>${d}</b><br>${params.filter(p=>p.value!==null&&p.value!==undefined).map(p=>`${p.marker} ${p.seriesName}: <b>${Number(p.value).toFixed(3)} €</b>`).join('<br>')}`;}},
    xAxis:{type:'category',data:dates,boundaryGap:false,axisLabel:{hideOverlap:true,color:chartText,fontFamily:'Rubik',fontSize:10,formatter:v=>dayjs(v).format('DD/MM')},axisLine:{lineStyle:{color:chartGrid}},axisTick:{show:false}},
    yAxis:{type:'value',scale:true,axisLabel:{formatter:v=>`${Number(v).toFixed(2)} €`,color:chartText,fontFamily:'Rubik',fontSize:10},splitLine:{lineStyle:{color:chartGrid}},axisLine:{show:false},axisTick:{show:false}},
    dataZoom:[{type:'inside',filterMode:'none'}],
    series
  };
  if(fuel!=='BENZINA'&&fuel!=='GASOLIO') return <ReactECharts style={{height}} option={option}/>;
  return <AnnotatedTimeChart
    option={option}
    dates={dates}
    height={height}
    fuels={[fuel]}
    analysisSeries={series.map(item=>({name:item.name,values:item.data}))}
  />;
}
